// @ts-nocheck
import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import qs from 'query-string';
import { Link } from 'react-router-dom';
import { withRouter } from '../../../../router-compat';

import configs from '../configs';
import { IntegrationLayout, ExternalLinkA } from '../_shared';
import Card, { CardHead } from '../../../ui/Card';
import Button from '../../../ui/Button';
import Switch from '../../../ui/Switch';

import TypeformCards from './Setup/Forms';
import TypeformSearch from './Setup/Search';
import TypeformPagination from './Setup/Pagination';

class Typeform extends Component {
  Typeform = this.props.store.integrations.Typeform;

  componentDidMount() {
    this.Typeform.getConfigs();
    if (this.Typeform.configs.enabled) this.Typeform.retrieveForms();
    const { code } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (code) {
      this.Typeform.getTokens(code).then(async () => {
        this.props.history.replace(this.props.location.pathname);
        await this.Typeform.getConfigs();
        this.Typeform.retrieveForms();
      });
    }
  }

  toggle = (v) => {
    this.Typeform.setConfigField('enabled', v);
  }

  render() {
    return (
      <IntegrationLayout config={configs.Typeform}>
        <Card padded className="mb-5">
          <CardHead title="Setup" />
          <ol className="m-0 pl-5 flex flex-col gap-2 text-[13px] leading-relaxed">
            <li>You MUST use Google Tag Manager for this integration to work.</li>
            <li>You MUST be on a Typeform paid plan (GTM containers attached to forms).</li>
            <li>Create a Typeform account <ExternalLinkA href="https://admin.typeform.com/signup">here</ExternalLinkA> if you don&apos;t have one already.</li>
            <li>
              <button
                type="button"
                onClick={this.Typeform.getAuthUrl}
                className="text-mov-accent-ink underline cursor-pointer font-medium"
                style={{ background: 'transparent', border: 0, padding: 0 }}
              >
                Authorize Movology
              </button>{' '}— your forms will load below.
            </li>
            <li>
              If you haven&apos;t already, add the Capture snippet to your GTM container via{' '}
              <Link to="/integrations/GoogleTagManager" className="text-mov-accent-ink underline">our GTM integration</Link>{' '}
              or manually from <Link to="/setup" className="text-mov-accent-ink underline">setup</Link>.
            </li>
            <li>Enter your GTM container ID on each form, then approve.</li>
            <li>
              Future captures will be accessible via{' '}
              <Link to="/dashboard" className="text-mov-accent-ink underline">dashboard</Link>{' '}and{' '}
              <Link to="/reporting" className="text-mov-accent-ink underline">reporting</Link>.
            </li>
          </ol>
        </Card>

        <Card padded className="mb-5">
          <CardHead title="Typeform forms" action={<TypeformSearch />} />
          {(this.Typeform.configs.enabled && !_.isEmpty(this.Typeform.formData)) && <TypeformCards />}
          <TypeformPagination />
        </Card>

        <Card padded>
          <CardHead
            title="Manage integration"
            action={(
              <div className="flex items-center gap-2">
                <span className="text-[12.5px] text-mov-ink-soft">Enabled</span>
                <Switch checked={!!this.Typeform.configs.enabled} onChange={this.toggle} />
              </div>
            )}
          />
          <div className="flex justify-end">
            <Button
              variant="primary"
              loading={this.Typeform.loading.configs}
              disabled={this.Typeform.loading.configs}
              onClick={() => this.Typeform.updateConfigs('Typeform')}
            >
              Update settings
            </Button>
          </div>
        </Card>
      </IntegrationLayout>
    );
  }
}

export default withRouter(inject('store')(observer(Typeform)));
